import { render, staticRenderFns } from "./userEdit.vue?vue&type=template&id=10321892&scoped=true&"
import script from "./userEdit.vue?vue&type=script&lang=js&"
export * from "./userEdit.vue?vue&type=script&lang=js&"
import style0 from "./userEdit.vue?vue&type=style&index=0&id=10321892&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10321892",
  null
  
)

export default component.exports